<template>
    <div>
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane v-for="(item, index) in priceList" :key="index" :label="item.tool_cat" :name="item.tool_cat">
                <el-table :data="item.list" border>
                    <el-table-column prop="tool_name" label="功能名称"></el-table-column>
                    <el-table-column prop="point" :label="getPriceColumnLabel(item, 'point_label')"></el-table-column>
                    <el-table-column prop="vip_point" :label="getPriceColumnLabel(item, 'vip_point_label')"></el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const initData = {
    验号中心: [
        {
            name: '旺旺照妖镜',
            // key: 'search', // 普通版 key
            key: 'searchplus', // 增强版 key
            simple: '30点券/次',
            vip: '5点券/次',
        },
        {
            name: '标签权重推送',
            key: 'searchpush',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '防P图验号',
            key: 'fangpitu',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '指数转算',
            key: 'computed',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '淘客订单查询',
            key: 'itemorder',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: 'DSR计算器',
            key: 'dsr',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: 'TOP20w词库',
            key: 'tao20w',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '搜索下拉推荐词',
            key: 'taosuggest',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '旺旺搜索词推荐',
            key: 'usertag',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '淘宝排名查询',
            // key: 'itemrank',
            showallIntro: true,
            simple: '免费查询前10页排名',
            vip: '免费查询前100页排名',
        },
        {
            name: '授权验号',
            key: 'checkGetNo',
            simple: '10点券/次',
            vip: '7点券/次',
        },
        {
            name: '竞品数据',
            key: 'goodsanalysis',
            simple: '30点券/次',
            vip: '10点券/次',
        },
        {
            name: '无痕做单普通版',
            key: 'noTraceSupplementOrdinary',
            simple: '95点券/次',
            vip: '35点券/次',
        },
        {
            name: '无痕做单高级版',
            key: 'noTraceSupplementSenior',
            simple: '95点券/次',
            vip: '35点券/次',
        },
        {
            name: '淘口令生成',
            key: 'taotokenadv', // 淘口令高级版
            simple: '20点券/次',
            vip: '10点券/次',
        },
        {
            name: '宝贝评价分析',
            key: 'getTaoBaoFeadback',
            simple: '2点券/次',
            vip: '1点券/次',
        },
        {
            name: '大数据验号',
            key: 'search',
            simple: '10点券/次',
            vip: '3点券/次',
        },
    ],
    礼品商城: [],
    卡首屏系列: [
        {
            name: '关键字卡首屏',
            key: 'firstscreen',
            simple: '免费使用',
            vip: '免费使用',
        },
        {
            name: '找相似入口',
            key: 'similar',
            simple: '免费使用',
            vip: '免费使用',
        },
        {
            name: '洋淘秀卡首屏',
            key: 'foreigntao',
            simple: '免费使用',
            vip: '免费使用',
        },
        {
            name: '旺旺强行打标',
            key: 'wwfscreen',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '拼多多打标',
            key: 'pddforcescreen',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '猜你喜欢',
            key: 'stguess',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '手淘推荐',
            key: 'cardFirstScreen',
            simple: '4点券/次',
            vip: '1点券/次',
        },
    ],
    流量入口系列: [
        {
            name: '有好货',
            key: 'stnicegoods',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '每日好店',
            key: 'stdayshops',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: 'iFashion',
            key: 'stifashion',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '淘抢购',
            key: 'strobshop',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '亲宝贝',
            key: 'stprobaby',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '潮玩城',
            key: 'sttideplay',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '极有家',
            key: 'stpolehome',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '首页钻展',
            key: 'sthbooth',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '全球购',
            key: 'stglobalshop',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '手淘清仓流量',
            key: 'cardFirstScreen',
            simple: '4点券/次',
            vip: '1点券/次',
        },
        {
            name: '手淘网红集合',
            key: 'cardFirstScreen',
            simple: '4点券/次',
            vip: '1点券/次',
        },
        {
            name: '生活研究所',
            key: 'cardFirstScreen',
            simple: '4点券/次',
            vip: '1点券/次',
        },
        {
            name: '中国制造',
            key: 'cardFirstScreen',
            simple: '4点券/次',
            vip: '1点券/次',
        },
        {
            name: '换新',
            key: 'cardFirstScreen',
            simple: '4点券/次',
            vip: '1点券/次',
        },
        {
            name: '汇吃',
            key: 'cardFirstScreen',
            simple: '4点券/次',
            vip: '1点券/次',
        },
    ],
    流量任务: [
        {
            name: '淘宝/天猫流量 APP搜索流量',
            key: 'trafficApp',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '淘宝/天猫流量 商品直接收藏',
            key: 'trafficDirectCollect',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '淘宝/天猫流量 商品直接加购',
            key: 'trafficDirectCart',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '京东流量 APP搜索流量',
            key: 'trafficJdApp',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '京东流量 直接加购',
            key: 'trafficJdDirectCart',
            simple: '10点券/次',
            vip: '3点券/次',
        },
        {
            name: '拼多多流量 APP搜索流量',
            key: 'trafficPddApp',
            simple: '10点券/次',
            vip: '3点券/次',
        },
    ],
    打单软件: [
        {
            name: '订单打印',
            // key: 'trafficApp',
            showallIntro: true,
            simple: '不可使用',
            vip: '免费使用',
        },
        {
            name: '订单发货',
            // key: 'trafficDirectCollect',
            showallIntro: true,
            simple: '不可使用',
            vip: '免费使用',
        },
        {
            name: '备注标旗',
            // key: 'trafficDirectCart',
            showallIntro: true,
            simple: '不可使用',
            vip: '免费使用',
        },
        {
            name: '导入发货',
            // key: 'trafficJdApp',
            showallIntro: true,
            simple: '不可使用',
            vip: '免费使用',
        },
        {
            name: '店铺管理',
            // key: 'trafficJdDirectCart',
            showallIntro: true,
            simple: '不可使用',
            vip: '免费使用',
        },
    ],
}
export default {
    computed: {
        ...mapState(['configData']),
        allConfigData() {
            if (this.configData.api_setting) {
                return { ...this.configData.api_setting, ...this.configData.traffic_setting }
            } else {
                return {}
            }

        },
    },
    data() {
        return {
            activeName: '验号中心',
            initData,
            priceList: [],
            point_label: '普通用户价格',
            vip_point_label: 'VIP用户价格',
        }
    },
    methods: {
        /** 列头文案在每条 list 记录上；同一 tab 内一致，取首行即可 */
        getPriceColumnLabel(tabItem, key) {
            const row = tabItem.list && tabItem.list[0]
            if (row && row[key]) return row[key]
            return key === 'point_label' ? this.point_label : this.vip_point_label
        },
        async getWarehouse() {
            const data = await this.$fetch('/shop/webs/v1/get-custom-warehouse', {}, 'post')
            if (data.code == 0 && data.data && data.data.length > 0) {
                let arr = data.data.map(item => {
                    return {
                        name: item.custom_warehouse_name,
                        simple: item.price,
                        vip: item.vip_price,
                        api: item.api_price,
                    }
                })
                this.initData['礼品商城'] = arr
            }
        },
        async getPriceList() {
            const res = await this.$fetch('/api/proxy/web/liuliang/price/list', {}, 'get')
            if (+res.code === 0) {
                let priceList = res.data
                if (priceList.length) {
                    priceList = priceList.filter(ele => {
                        return (ele['tool_cat'] !== '兑换点券' && ele['tool_cat'] !== '流量任务')
                    });
                }

                priceList.forEach(ele => {
                    ele.list.forEach(item => {
                        item.point_label = this.point_label
                        item.vip_point_label = this.vip_point_label
                    })
                })

                priceList.push({
                    "tool_cat": "子账号管理",
                    "list": [
                        {
                            "tool_name": "子账号上限",
                            "point": 0,
                            "vip_point": 3,
                            "tool_cat": "子账号管理",
                            "point_label": "普通用户",
                            "vip_point_label": "VIP用户",
                        },
                    ]
                })
                this.priceList = priceList

                if (priceList.length) {
                    this.activeName = priceList[0].tool_cat;
                }
            }
        },
    },
    mounted() {
        this.getWarehouse()
        this.getPriceList()
    },
}
</script>

<style lang="scss" scoped></style>
